import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import HeaderWithButton from "../../Utility/HeaderWithButton";
import { PencilSquareIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { Tooltip } from "react-tooltip";
import DeleteConfirmation from "../../Utility/DeleteConfirmation";
import { Dialog } from "@headlessui/react";
import { DataContext } from "../../../helper/HelperOne";
import { Pagination } from "../../../helper/HelperTwo";
import { useToast } from "../../../context/ToastProvider";

const SalesOrderStatusList = () => {

  const { triggerToast } = useToast();
  const { searchData } = useContext(DataContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [errors, setErrors] = useState(null);
  const [salesorderStatusListButton, setsalesorderStatusListButton] = useState("");
  const [salesorderStatusListData, setsalesorderStatusListData] = useState([]);
  const [editsalesorderStatusList, setEditsalesorderStatusList] = useState("");
  const [paginationsalesorderListData, setPaginationsalesorderListData] = useState([]);
  const [editsalesorderId, setEditsalesorderId] = useState("");
  const [salesOrderStatusInputs, setSalesOrderStatusInputs] = useState({
    status: "",
  });


  const fetchSostatusList = async (page = 1) => {
    const token = localStorage.getItem("token");
    if (!token) {
      triggerToast("error", "Authorization token is missing", "error");
      // toast.error("Authorization token is missing");
      return;
    }

    try {
      const apiUrl = searchData
        ? `public/api/sales-orders-status\?page=${page}&search=${searchData}`
        : `public/api/sales-orders-status?page=${page}`;

      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

   

      setsalesorderStatusListData(response?.data?.sales_order_status);
      setPaginationsalesorderListData(response?.data?.sales_order_status);
    } catch (error) {
      console.error("Error fetching lead sources:", error);
    }
  };
  useEffect(() => {
    fetchSostatusList(currentPage);
  }, [searchData, currentPage])

  const handleAddSoStatusList = () => {
    setIsDialogOpen(true);
    setsalesorderStatusListButton("save");
    setSalesOrderStatusInputs({ status: "" });
  }

  const handleChangeForSoStatus = (e) => {
    setSalesOrderStatusInputs({
      [e.target.name]: e.target.value,
    });
  };

  const handleSaveSostatusList = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        "public/api/sales-orders-status",
        salesOrderStatusInputs,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      setIsDialogOpen(false);

      triggerToast("success", "Sales Order Status added successfully", "success");
      fetchSostatusList();
    } catch (error) {
      triggerToast("error", "Failed to add Sales Order Status", "error");
   
      setErrors(error.response.data.errors);
    }
  }


  const handleEditSoStatus = async (id) => {
    setEditsalesorderId(id);
    setIsDialogOpen(true);

    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`public/api/sales-orders-status/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      

      const statusData = response.data;

      // Correctly setting the state
      setSalesOrderStatusInputs({ status: statusData?.status });

      setEditsalesorderId(id);
      setsalesorderStatusListButton("update");
      setIsDialogOpen(true);

    } catch (error) {
      triggerToast("error", "Failed to fetch Quotation Sales Order Status for editing", "error");
    }
  }

  const handleUpdateSoStatus = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      setsalesorderStatusListButton("update");
      const response = await axios.put(
        `public/api/sales-orders-status/${editsalesorderId}`,
        salesOrderStatusInputs,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        setIsDialogOpen(false);
        triggerToast("success", "Sales Order Status updated successfully", "success");
        // toast.success("Sales Order Status updated successfully");
        await fetchSostatusList();
      } else {
        triggerToast("error", "Failed to update sales Order Status", "error");
        // toast.error("Failed to update Sales Order Status");
      }
    } catch (error) {
      triggerToast("error", "Failed to update Sales Order Status", "error");
    }
  }

  return (
    <div> <HeaderWithButton
      title="Sales Order Status"
      description="Sales Order Status"
      buttonText=" Status"
      onButtonClick={handleAddSoStatusList}
    // showButton={leadLostReasonListPermission}
    />

      <div className="grid grid-cols-1 gap-4 items-start sm:items-center">
        <div className="mt-6 overflow-x-auto rounded-lg shadow">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
                  S No
                </th>
                <th className="py-3 px-5 border-b text-center text-sm sm:text-base font-normal">
                  Sales Order Status
                </th>
                <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
                  Actions
                </th>
              </tr>
            </thead>

            <tbody className="bg-white divide-y divide-gray-200 ">
              {salesorderStatusListData?.data?.length > 0 ? (
                salesorderStatusListData?.data.map((item, index) => (
                  <tr key={index}>
                    <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                      {index + 1}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">
                      {item.status}
                    </td>
                    <td className="my-anchor-edit px-6 py-4 whitespace-nowrap text-right text-sm font-medium flex justify-center">
                      <>
                        <button
                          className="my-anchor-edit bg-green-400 text-white text-sm py-1 px-2 rounded mr-2 transition duration-200"
                          onClick={() =>
                            handleEditSoStatus(
                              item.id_crypt
                            )
                          }
                        >
                          <PencilSquareIcon className="h-5 w-5 text-white" />
                          <Tooltip
                            anchorSelect=".my-anchor-edit"
                            place="top"
                            className="text-xs p-0"
                            style={{ fontSize: "12px", padding: "0.3rem" }}
                          >
                            Edit
                          </Tooltip>
                        </button>

                        <DeleteConfirmation
                          id_crypt={item.id_crypt}
                          apiType="salesOrderStatus"
                          fetchClientData={fetchSostatusList}
                        />
                      </>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="py-3 px-5 border-b text-center text-sm sm:text-base font-normal">
                    No Data Found
                  </td>
                </tr>

              )}
            </tbody>
          </table>
        </div>

      </div>
      {isDialogOpen && (
        <Dialog
          open={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
          className="relative z-10"
        >
          <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-50 backdrop-blur-sm transition-opacity" />
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
              <Dialog.Panel className="my-auto relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto">
                <div
                  className="flex justify-between items-center mb-4 p-4"
                  style={{ backgroundColor: "#6366f1" }}
                >
                  <h1 className=" text-white mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium mb-2 uppercase z-100">
                    Sales Order Status
                  </h1>
                  <button
                    type="button"
                    onClick={() => setIsDialogOpen(false)}
                  >
                    <XMarkIcon
                      className="h-6 w-6 sm:h-8 sm:w-8 text-white cursor-pointer"
                      aria-hidden="true"
                    />
                  </button>
                </div>
                <div className="w-full max-w-7xl mx-auto p-6 bg-gray-50">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="sm:col-span-2">
                      <form>
                        <div className="overflow-hidden sm:rounded-md">
                          <div className="space-y-4">
                            <div>
                              <label
                                htmlFor="status"
                                className="block text-sm font-medium leading-6 text-gray-900"
                              >
                                Status
                              </label>
                              <div className="mt-2">
                                <input
                                  name="status"
                                  type="text"
                                  value={salesOrderStatusInputs.status}
                                  onChange={handleChangeForSoStatus}
                                  autoComplete="mode"
                                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                              {errors && (
                                <p className="mt-1 text-sm text-red-600">
                                  {errors.status}
                                </p>
                              )}
                            </div>

                            <div className="flex  space-x-2">
                              {salesorderStatusListButton === "save" ? (
                                <button
                                  onClick={handleSaveSostatusList}
                                  className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                  Add
                                </button>
                              ) : (
                                <button
                                  onClick={handleUpdateSoStatus}
                                  className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                  Update
                                </button>
                              )}
                              <button
                                type="button"
                                onClick={() => setIsDialogOpen(false)}
                                className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  )
}

export default SalesOrderStatusList